import React from 'react';
import './ComparisonSlider.css';

const ComparisonSlider = ({ 
    position, 
    onPositionChange,
    leftYear,
    rightYear,
    layerType
}) => {
    const handleMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent map from receiving the event
        
        const handleMouseMove = (moveEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation(); // Prevent map panning
            
            const container = document.getElementById('map');
            if (!container) return;
            
            const rect = container.getBoundingClientRect();
            const x = moveEvent.clientX - rect.left;
            const percentage = (x / rect.width) * 100;
            
            onPositionChange(Math.max(0, Math.min(100, percentage)));
        };
        
        const handleMouseUp = (upEvent) => {
            upEvent.preventDefault();
            upEvent.stopPropagation();
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleTouchStart = (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent map from receiving the event
        
        const handleTouchMove = (moveEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation();
            
            const container = document.getElementById('map');
            if (!container) return;
            
            const touch = moveEvent.touches[0];
            const rect = container.getBoundingClientRect();
            const x = touch.clientX - rect.left;
            const percentage = (x / rect.width) * 100;
            
            onPositionChange(Math.max(0, Math.min(100, percentage)));
        };
        
        const handleTouchEnd = (endEvent) => {
            endEvent.preventDefault();
            endEvent.stopPropagation();
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };
        
        document.addEventListener('touchmove', handleTouchMove, { passive: false });
        document.addEventListener('touchend', handleTouchEnd);
    };

    return (
        <div 
            className="comparison-slider-container"
            style={{ left: `${position}%` }}
        >
            <div 
                className="comparison-slider-handle"
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
            >
                <div className="slider-line" />
                <div className="slider-button">
                    <span className="arrow-left">◀</span>
                    <span className="divider">|</span>
                    <span className="arrow-right">▶</span>
                </div>
            </div>
            
            <div className="year-label year-label-left">
                {leftYear}
            </div>
            <div className="year-label year-label-right">
                {rightYear}
            </div>
        </div>
    );
};

export default ComparisonSlider;